<template>
<div>
  <FormulateInput
    v-if="personalizedType !== 'clipartCategory' && layer.imageSpiralLyric"
    :name="layer.id"
    :fontJsonSpiral='layer.fontJsonSpiral'
    :lyricTextDefault='layer.lyricTextDefault'
    :colorTextSpiral="layer.colorTextSpiral"
    :typeSpiral='layer.typeSpiral'
    :lyricIdParent="LyricIdParent"
    :defaultFontSizeSpiralLyric='defaultFontSizeSpiralLyric'
    :svgUrlSpiralLyric='svgUrlSpiralLyric'
    :minCharacters='minCharacters'
    :maxCharacters='maxCharacters'
    @ChangeTextSongLyric="ChangeTextSongLyric"
    type="imagelyricsspiral"
  />

  <FormulateInput
    v-if="personalizedType !== 'clipartCategory' && !layer.imageSpiralLyric"
    :name="layer.id"
    :colortextlyrics="layer.colorTextLyrics"
    :shapes="layer.shapes[0]['file']['key']"
    :fontfamilyurl="layer.fontFamilyUrl"
    :lyricIdParent="LyricIdParent"
    @ChangeTextSongLyric="ChangeTextSongLyric"
    type="imagelyrics"
  />
</div>
</template>

<script>
import { get } from 'lodash'

export default {
  name: 'lyrics-field',
  components: {

  },
  props: {
    layer: {
      type: Object,
      required: true
    },
    artwork: {
      type: Object,
      required: true
    },
    personalized: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {

    }
  },
  mounted() {

  },
  watch: {

  },
  computed: {
    personalizedType() {
      return this.layer.personalized.type
    },
    required() {
      return get(this.layer, 'personalized.required', false)
    },
    initialValue() {
      const { personalized, layer } = this
      return get(personalized, layer.id)
    },
    label() {
      return get(this.layer, 'personalized.label', this.layer.title)
    },
    aspectRatio() {
      const { layer } = this
      return layer.width / layer.height
    },
    LyricIdParent(){
      const {layer} = this
      return get(layer, 'LyricIdParent', null)
    },
    defaultFontSizeSpiralLyric() {
      const {layer} = this;
      return get(layer, 'defaultFontSizeSpiralLyric', 16)
    },
    svgUrlSpiralLyric() {
      const {layer} = this;
      const dataDefault = {
        name: null,
        value: null
      }
      return get(layer, 'svgUrlSpiralLyric', dataDefault);
    },
    minCharacters(){
      const {layer} = this;
      return get(layer, 'minCharacters', 0);
    },
    maxCharacters(){
      const {layer} = this;
      return get(layer, 'maxCharacters', 1200);
    }
  },
  methods: {
    ChangeTextSongLyric(value){
      this.$emit('ChangeTextSongLyric', value)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Form/LyricsField.vue